import React, { useRef } from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import UseEligibility from 'MainTabs/Eligibility/Components/EligibilityLogDetail/UseEligibility'
import HomeView from 'MainTabs/Eligibility/Components/EligibilityLogDetail/HomeView'
import BenefitsView from 'MainTabs/Eligibility/Components/EligibilityLogDetail/BenefitsView'
import { useReactToPrint } from 'react-to-print';
import { TODAY_DATE } from 'Common/Constants'
import { useSelector } from 'react-redux'
import moment from "moment-mini";
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'

const FullScreenEligibilityPopup = ({ onClose, eligibilityData, onOpenCoPaymentPopup }) => {
    const [handleClick, visibleItemId, distinctBenifits, arrr, itemsRef] = UseEligibility(eligibilityData)
    const { userinfo, practiceDetails } = useSelector((state) => state.userAuth);
    const contentToPrint = useRef(null);
    const handlePrintPKG = useReactToPrint({
        documentTitle: "Eligibility Log",
        // onBeforePrint: () => ,
        // onAfterPrint: () =>  ,
        removeAfterPrint: false,
        // print: customToPrint,
    });

    return (
        <ReactPortal wrapperId="FullScreenEligibilityPopup">
            <div data-te-modal-init className="fixed left-0 top-0 z-[10] h-full w-full overflow-y-auto overflow-x-hidden outline-none" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" style={{ display: 'block' }} aria-modal="true" role="dialog" data-te-open="true">
                <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
                <div data-te-modal-dialog-ref className="flex w-screen h-screen ">
                    <div className="pointer-events-auto p-5 relative flex max-h-[100%] w-full flex-col overflow-hidden rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600">
                        <div className='flex justify-between pb-3 text-2xl font-semibold border-b'>
                            <p>Eligibility Log Detail</p>
                            <div className='flex items-center gap-3'>
                                <img className='h-5 cursor-pointer' title="Go Fullscreen" onClick={onClose} src="/img/closeScreen.svg" alt="closeScreen" />
                                <CustomButtonNew onClick={() => { handlePrintPKG(null, () => contentToPrint.current); }} label="Print" />
                            </div>

                        </div>
                        {/* <div className='h-full'>
                            <div className='bg-[#F6F8FA] pt-4 pb-4 px-2 h-full'>

                            </div>
                        </div> */}
                        <div className="relative overflow-y-hidden">
                            <div className='grid grid-cols-12 gap-4'>
                                <div className='col-span-4 max-h-[87vh] px-2 py-4 overflow-auto bg-white rounded-md '>
                                    <ul>
                                        <li onClick={() => handleClick({ benefitDescription: "home" })} className={` ${visibleItemId === "home" ? "text-secondary font-medium" : "text-secondaryLight"}  px-3 pb-2 mb-3 border-b cursor-pointer `}>Home</li>
                                        {
                                            distinctBenifits.map((log) => {
                                                return (
                                                    <li key={log.id} onClick={() => handleClick(log)} className={` ${visibleItemId === log.benefitDescription ? "text-secondary font-medium" : "text-secondaryLight"}  px-3 pb-2 mb-3 border-b cursor-pointer `}>{log.benefitCode} - {log.benefitDescription}</li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                                <div id="printPreview" ref={contentToPrint} className='max-h-[87vh] scroll-container col-span-8 p-5 overflow-auto bg-white '>
                                    <ul>
                                        {arrr.map((benefit, i) => {
                                            if (benefit.benefitDescription === "home") {
                                                return (<li ref={(el) => (itemsRef.current[i] = el)} id={benefit.benefitDescription} >
                                                    <HomeView subscriberInformation={benefit} eligibilityData={eligibilityData} />
                                                </li>)
                                            }
                                            else {
                                                let [key] = Object.entries(benefit)

                                                return <li className='relative mb-5 '>
                                                    <span ref={(el) => (itemsRef.current[i] = el)} id={key[0]} className='bg-none  pointer-events-none h-[200px] w-full absolute top-0'></span>
                                                    <BenefitsView
                                                        name={key[0]}
                                                        benefit={key[1]}
                                                        onCoPaymentClick={(benefit) => {
                                                            const amount = benefit?.benefitAmount ?? 0;
                                                            const serviceDate = eligibilityData?.eligibilityDate?.split?.('T')?.[0] ?? '';
                                                            onOpenCoPaymentPopup?.({ patientId: eligibilityData?.patientId, amount, serviceDate });
                                                        }}
                                                    />
                                                </li>
                                            }
                                        })}
                                    </ul>
                                    <div className='justify-between hidden mt-4 font-semibold print:flex'>
                                        <p>Downloaded By : {userinfo.userName}</p>
                                        <p>Date : {moment(TODAY_DATE).format("MM/DD/YYYY")}</p>
                                        <p>Practice : {practiceDetails.name}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </ReactPortal>
    )
}

export default FullScreenEligibilityPopup

